export default {
  en: {
    operationType: 'Operation Type',
    feeFromUsedPercent: 'Fee From Used, %',
    feeFromUnusedPercent: 'Fee From Unused, %',
    lPaymentMethod: 'payment method',
    failedPaymentSettings: 'Failed payment settings',
    paymentSettings: 'Payment settings',
    pay: 'Pay',
    deposits: 'Deposits',
    withdrawals: 'Withdrawals',
    transactionInitData: 'Transaction Initial Data',
    transactionDetails: 'Transaction Details',
    betshop: 'Betshop',
    lastTag: 'Last Tag',
    viewTags: 'View Tags',
    taggedDate: 'Tagged Date',
    taggedBy: 'Tagged By',
    assignedTags: 'Assigned Tags',
    ruleId: 'Rule ID',
    withdrawalsWhichStatusWillChanged: 'Withdrawals which status will be changed',
    withdrawalsWhichStatusWillNotChanged: 'Withdrawals which status will not be changed',
    twoHours: 'two hours',
    autoRefreshDepositsInfo: 'Activating auto-refresh mode in the report will display the deposits created within the last hour',
    autoRefreshWithdrawalsInfo: 'Activating auto-refresh mode in the report will display the withdrawals created within the last hour',
    refund: 'Refund',
    refundState: 'Refund State',
    integerNumber: 'integer number',
  },
  es: {
    operationType: 'Tipo de operación',
    feeFromUsedPercent: 'Cuota de uso, %',
    feeFromUnusedPercent: 'Cuota de no uso, %',
    lPaymentMethod: 'método de pago',
    failedPaymentSettings: 'Ajustes de pago fallidos',
    paymentSettings: 'Ajustes de pago',
    pay: 'Pagar',
    deposits: 'Depósitos',
    withdrawals: 'Retiros',
    transactionInitData: 'Datos iniciales de la transacción',
    transactionDetails: 'Detalles de la transacción',
    betshop: 'Casa de Apuestas',
    lastTag: 'Última Etiqueta',
    viewTags: 'Ver Etiquetas',
    taggedDate: 'Fecha de Etiquetado',
    taggedBy: 'Etiquetado Por',
    assignedTags: 'Etiquetas Asignadas',
    ruleId: 'ID de Regla',
    withdrawalsWhichStatusWillChanged: 'Retiros cuyo estado será cambiado',
    withdrawalsWhichStatusWillNotChanged: 'Retiros cuyo estado no será cambiado',
    autoRefreshDepositsInfo: 'Activar el modo de actualización automática en el informe mostrará los depósitos creados durante la última hora.',
    autoRefreshWithdrawalsInfo: 'Activar el modo de actualización automática en el informe mostrará los retiros creados durante la última hora.',
  },
  tr: {
    operationType: 'Operasyon Türü',
    feeFromUsedPercent: 'Kullanılandan Ücret, %',
    feeFromUnusedPercent: 'Kullanılmayandan Ücret, %',
    lPaymentMethod: 'ödeme yöntemi',
    failedPaymentSettings: 'Ödeme ayarları başarısız',
    paymentSettings: 'Ödeme ayarları',
    pay: 'Öde',
    deposits: 'Para Yatırma İşlemleri',
    withdrawals: 'Para Çekme İşlemleri',
    transactionInitData: 'İşlem Başlangıç Verileri',
    transactionDetails: 'İşlem Detayları',
    betshop: 'Bayii',
    lastTag: 'Son Etiket',
    viewTags: 'Etiketleri Görüntüle',
    taggedDate: 'Etiketlenen Tarih',
    taggedBy: 'Etiketleyen',
    assignedTags: 'Atanmış Etiketler',
    ruleId: 'Kural ID',
    withdrawalsWhichStatusWillChanged: 'Durumu değiştirilecek çekimler',
    withdrawalsWhichStatusWillNotChanged: 'Durumu değiştirilmeyecek çekimler',
    autoRefreshDepositsInfo: 'Raporda otomatik yenileme modunu etkinleştirdiğinizde, son bir saat içinde oluşturulan para yatırma işlemleri görüntülenir.    ',
    autoRefreshWithdrawalsInfo: 'Raporda otomatik yenileme modunu etkinleştirdiğinizde, son bir saat içinde oluşturulan para çekme işlemleri görüntülenir.',
  },
  ru: {
    operationType: 'Тип операции',
    feeFromUsedPercent: 'Комиссия с использованного, %',
    feeFromUnusedPercent: 'Комиссия с неиспользованного, %',
    lPaymentMethod: 'способ оплаты',
    failedPaymentSettings: 'Настройки отклоненных платежей',
    paymentSettings: 'Настройки платежей',
    pay: 'Оплата',
    deposits: 'Депозиты',
    withdrawals: 'Вывод средств',
    transactionInitData: 'Исходные данные транзакции',
    transactionDetails: 'Подробности транзакции',
    betshop: 'Бетшоп',
    lastTag: 'Последний тег',
    viewTags: 'Смотреть теги',
    taggedDate: 'Дата по тегам',
    taggedBy: 'Отмечен тегом',
    assignedTags: 'Назначенные теги',
    ruleId: 'ID правила',
    withdrawalsWhichStatusWillChanged: 'Вывод средств, статус которого будет изменен',
    withdrawalsWhichStatusWillNotChanged: 'Вывод средств, статус которого не будет изменен',
    autoRefreshDepositsInfo: 'При включении режима автообновления в отчете будут отображаться депозиты, созданные за последний час',
    autoRefreshWithdrawalsInfo: 'При включении режима автообновления в отчете будут отображаться выводы средств, созданные в течение последнего часа',
  },
  pt: {
    operationType: 'Tipo de Operação',
    feeFromUsedPercent: 'Taxa de Utilizado, %',
    feeFromUnusedPercent: 'Taxa de Não Utilizado, %',
    lPaymentMethod: 'forma de pagamento',
    failedPaymentSettings: 'Falha nas configurações de pagamento',
    paymentSettings: 'Configurações de pagamento',
    pay: 'Pagar',
    deposits: 'Depósitos',
    withdrawals: 'Levantamentos',
    transactionInitData: 'Dados Iniciais da Transação',
    transactionDetails: 'Detalhes da Transação',
    betshop: 'Loja de apostas',
    lastTag: 'Última Tag',
    viewTags: 'Ver Tags',
    taggedDate: 'Data das etiquetas',
    taggedBy: 'Marcado por',
    assignedTags: 'Etiquetas atribuídas',
    ruleId: 'ID da Regra',
    withdrawalsWhichStatusWillChanged: 'Retiradas cujo estado será alterado',
    withdrawalsWhichStatusWillNotChanged: 'Retiradas cujo estado não será alterado',
    autoRefreshDepositsInfo: 'A ativação do modo de atualização automática no relatório exibirá os depósitos criados na última hora',
    autoRefreshWithdrawalsInfo: 'A ativação do modo de atualização automática no relatório exibirá os saques criados na última hora',
  },
  zh: {
    operationType: '运营类型',
    feeFromUsedPercent: '来自使用过的费用，％',
    feeFromUnusedPercent: '未使用的费用，％。',
    lPaymentMethod: '付款方式',
    failedPaymentSettings: '支付设置失败',
    paymentSettings: '付款设置',
    pay: '付款',
    deposits: '存款',
    withdrawals: '取款',
    transactionInitData: '交易初始数据',
    transactionDetails: '交易细节',
    betshop: '投注站',
    lastTag: '最后标签',
    viewTags: '查看标签',
    taggedDate: '标签日期',
    taggedBy: '标签',
    assignedTags: '已分配标签',
    ruleId: '规则ID',
    withdrawalsWhichStatusWillChanged: '将更改状态的提款',
    withdrawalsWhichStatusWillNotChanged: '状态不会改变的提款',
    autoRefreshDepositsInfo: '在报告中激活自动刷新模式将显示过去一小时内创建的存款',
    autoRefreshWithdrawalsInfo: '在报告中激活自动刷新模式将显示过去一小时内创建的取款',
  },
  ro: {
    operationType: 'Tip de operație',
    feeFromUsedPercent: 'Taxa din utilizat, %',
    feeFromUnusedPercent: 'Taxa din neutilizat, %',
    lPaymentMethod: 'metodă de plată',
    failedPaymentSettings: 'Setări de plată eșuate',
    paymentSettings: 'Setări de plată',
    pay: 'Plată',
    deposits: 'Depuneri',
    withdrawals: 'Retrageri',
    transactionInitData: 'Data inițială de tranzacție',
    transactionDetails: 'Detalii de tranzacție',
    betshop: 'Case de pariuri',
    lastTag: 'Ultima etichetă',
    viewTags: 'Vizualizare etichete',
    taggedDate: 'Data etichetării',
    taggedBy: 'Etichetat de',
    assignedTags: 'Etichete alocate',
    ruleId: 'ID regulă',
    withdrawalsWhichStatusWillChanged: 'Retrageri a căror stare va fi schimbată',
    withdrawalsWhichStatusWillNotChanged: 'Retrageri a căror stare nu va fi schimbată',
    autoRefreshDepositsInfo: 'Prin activarea modului de reîmprospătare automată în raport se vor afișa depunerile create în ultima oră',
    autoRefreshWithdrawalsInfo: 'Prin activarea modului de reîmprospătare automată în raport se vor afișa retragerile create în ultima oră',
  },
  bg: {},
  el: {
    operationType: 'Τύπος λειτουργίας',
    feeFromUsedPercent: 'Χρέωση από χρησιμοποιημένο, %',
    feeFromUnusedPercent: 'Χρέωση από αχρησιμοποίητο, %',
    lPaymentMethod: 'μέθοδος πληρωμής',
    failedPaymentSettings: 'Ρυθμίσεις αποτυχημένης πληρωμής',
    paymentSettings: 'Ρυθμίσεις πληρωμής',
    pay: 'Πληρωμή',
    deposits: 'Καταθέσεις',
    withdrawals: 'Αναλήψεις',
    transactionInitData: 'Αρχικά δεδομένα συναλλαγής',
    transactionDetails: 'Στοιχεία συναλλαγής',
    betshop: 'Κατάστημα στοιχηματισμού',
    lastTag: 'Τελευταία ετικέτα',
    viewTags: 'Προβολή ετικετών',
    taggedDate: 'Ημερομηνία ανάθεσης ετικέτας',
    taggedBy: 'Η ετικέτα ανατέθηκε από',
    assignedTags: 'Ανατεθειμένες ετικέτες',
    ruleId: 'Αναγνωριστικό κανόνα',
    withdrawalsWhichStatusWillChanged: 'Αναλήψεις των οποίων η κατάσταση θα αλλάξει',
    withdrawalsWhichStatusWillNotChanged: 'Αναλήψεις των οποίων η κατάσταση δεν θα αλλάξει',
    autoRefreshDepositsInfo: 'Αν ενεργοποιήσετε τη λειτουργία αυτόματης ανανέωσης στην αναφορά, θα προβάλλονται οι καταθέσεις που δημιουργήθηκαν εντός της τελευταίας ώρας',
    autoRefreshWithdrawalsInfo: 'Αν ενεργοποιήσετε τη λειτουργία αυτόματης ανανέωσης στην αναφορά, θα προβάλλονται οι αναλήψεις που δημιουργήθηκαν εντός της τελευταίας ώρας',
  },
};
